import React from "react";
import { Provider } from "react-redux";
import { useStore } from "./redux/store";
import RouterComponent from "./Router";
import { ConfigProvider } from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import "./App.less";
const App = () => {
  const store = useStore();
  console.log("store", store.getState());
  return (
    <div className="App">
      <Provider store={store}>
        <ConfigProvider locale={zhCN}>
          <RouterComponent />
        </ConfigProvider>
      </Provider>
    </div>
  );
};

export default App;
